import React from 'react';
import './ListingsLoading.css';
const ListingsLoading = () => {
  return (
    <div className='ml-4 sm:ml-[10%] mr-4 sm:mr-[10%] lg:ml-[15%] lg:mr-[26%] mt-10 lg:mt-[35px] mb-10 lg:mb-[85px] overflow-hidden rounded-xl transition-all duration-100 propertyCard'>
      <div className='animate-pulse sm:flex space-x-4 pb-0.5 p-[18px]'>
        <div className="flex items-center justify-center h-52 sm:h-[364px] bg-slate-200 rounded-2xl sm:w-[483px] dark:bg-gray-700">
          <svg className="w-12 h-12 text-slate-200" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"
            fill="currentColor" viewBox="0 0 640 512">
            <path
              d="M480 80C480 35.82 515.8 0 560 0C604.2 0 640 35.82 640 80C640 124.2 604.2 160 560 160C515.8 160 480 124.2 480 80zM0 456.1C0 445.6 2.964 435.3 8.551 426.4L225.3 81.01C231.9 70.42 243.5 64 256 64C268.5 64 280.1 70.42 286.8 81.01L412.7 281.7L460.9 202.7C464.1 196.1 472.2 192 480 192C487.8 192 495 196.1 499.1 202.7L631.1 419.1C636.9 428.6 640 439.7 640 450.9C640 484.6 612.6 512 578.9 512H55.91C25.03 512 .0006 486.1 .0006 456.1L0 456.1z"/>
          </svg>
        </div>
        <div className='relative flex-1 space-y-6 pl-4 mt-5 py-4'>
          <div className='h-2 bg-slate-200 rounded mr-64'></div>
          <div className='space-y-3'>
            <div className='grid grid-cols-3 '>
              <div className='h-2 bg-slate-200 rounded col-span-2'></div>
            </div>
            <div className='grid grid-cols-3 gap-4'>
              <div className='h-2 bg-slate-200 rounded col-span-1 mt-6'></div>
            </div>
            <div className='grid grid-cols-2 gap-4'>
              <div className='h-9 bg-slate-200 rounded col-span-1 mt-2'></div>
            </div>
            <div className='grid grid-cols-2 gap-4 absolute bottom-24 left-5 right-0'>
              <div className=''>
                <div className='h-2 bg-slate-200 rounded col-span-1 mt-3'></div>
                <div className='h-2 bg-slate-200 rounded col-span-1 mt-2'></div>
              </div>
              <div className='flex justify-center'>
                <div className='h-8 bg-slate-200 rounded col-span-1 w-1/2 flex  mt-2'></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="border-2 border-slate-200 mt-10 mb-5 mx-5"></div>
      <div className='grid grid-cols-3 mb-6 mx-5'>
        <div className='flex space-x-4'>
          <div className='p-4 rounded-md bg-slate-200'></div>
          <div className='p-4 rounded-md bg-slate-200'></div>
          <div className='p-4 rounded-md bg-slate-200'></div>
        </div>
        <div className='flex justify-center'>
          <div className='p-4 rounded-full bg-slate-200'></div>
        </div>
        <div className='flex justify-end'>
          <div className='p-4 rounded-md bg-slate-200'></div>
        </div>
      </div>
    </div>
  );
};

export { ListingsLoading };
